<p>dialog-user-type-add works!</p>
